<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{modalName}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal">
                </div>
                <hr>
                <div>
                    <div class="modal-form">
                        <div class="row mainRow">
                            <h5 class="headingText">Booking Number </h5>
                            <div>
                                <h5 class="headingText">#{{singleBooking?.reservation_code}}</h5>

                            </div>
                        </div>
                        <div class="row mainRow" *ngIf="singleBooking?.referrer != null">
                            <h6 class="headingTextSource">Booking Referrer </h6>
                            <div class="referrer">
                                {{singleBooking?.referrer}}</div>
                        </div>
                        <div class="row mainRow">
                            <h6 class="headingTextSource">Booking Source </h6>
                            <div>
                                <h6 class="headingTextSource">{{singleBooking?.source}}</h6>
                            </div>
                        </div>
                        <div class="row mainRow">
                            <h6 class="headingTextSource">Booking Brand </h6>
                            <div>
                                <h6 class="headingTextSource">{{singleBooking?.brand_id}}</h6>
                            </div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col">
                                <div class="row ">
                                    <h5 class="secondHeaderText">Booking Summary </h5>
                                </div>
                                <div class="col mt-2 bookingSumContainer">
                                    <div class="row iconContainer">
                                        <img class="saveIcon" src="../../../../../assets/icons/calendarIcon.png" />
                                        <p class="secondHeadingText">
                                            {{singleBooking?.start_datetime | date: "EEEE, d, MMMM"}}
                                        </p>
                                    </div>
                                    <div class="row iconContainer">
                                        <img class="saveIcon" src="../../../../../assets/icons/time.png" />
                                        <p class="secondHeadingText">{{singleBooking?.start_datetime | date: "hh:mm a"}}
                                        </p>
                                    </div>
                                    <div class="row iconContainer">
                                        <img class="saveIcon" src="../../../../../assets/icons/bookfor.png" />
                                        <p class="secondHeadingText">Book for {{bookedDuration}}</p>
                                    </div>
                                    <div class="row iconContainer">
                                        <img class="saveIcon" src="../../../../../assets/icons/peopleBlack.png" />
                                        <p class="secondHeadingText">{{singleBooking?.party_size}} People </p>
                                    </div>
                                    <div *ngIf="singleBooking?.table != null" class="row iconContainer">
                                        <img class="saveIcon" src="../../../../../assets/icons/Table.png" />
                                        <p class="secondHeadingText">{{singleBooking?.table.name}} </p>
                                    </div>
                                    <div class="row iconContainer">
                                        <img class="saveIcon" src="../../../../../assets/icons/Reserve.png" />
                                        <p class="secondHeadingText">Reservation Type :
                                            {{singleBooking?.reservation_type?.name}} (Zone :
                                            {{singleBooking?.zone?.name}})
                                        </p>
                                    </div>
                                    <div class="row iconContainer" *ngIf="singleBooking?.payment != null">
                                        <img class="paymentIcon" src="../../../../../assets/icons/payment.png" />
                                        <p class="secondHeadingText"> {{(singleBooking?.payment?.payment_amount /
                                            100).toFixed(2) |
                                            currency: currency}}</p>
                                        <div class="refundStatus" *ngIf="singleBooking?.payment?.is_refund != 0 ">
                                            <div class="text-white text-[10px]">Refunded</div>
                                        </div>
                                    </div>
                                    <div class="offer" *ngIf="singleBooking?.offer_value != null">
                                        {{singleBooking?.offer_value}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="margin-top: 5%;">
                                <div class="row iconContainer">
                                    <img class="saveIcon" src="../../../../../assets/icons/userIcon.png" />
                                    <span class="secondHeaderText marginLeft">Customer Details</span>
                                </div>
                                <div class="col marginTop bookingUserSum">
                                    <div class="row iconContainer">
                                        <div class="col col-4">
                                            <span class="secondText">Full Name</span>
                                        </div>
                                        <div class="col col-6">
                                            <span class="secondDecText">{{singleBooking?.first_name + " " +
                                                singleBooking?.last_name}}</span>
                                        </div>
                                    </div>
                                    <div class="row iconContainer">
                                        <div class="col col-4">
                                            <span class="secondText">Email Address</span>
                                        </div>
                                        <div class="col col-6">
                                            <span class="secondDecText">{{singleBooking?.email}}</span>
                                        </div>
                                    </div>
                                    <div class="row iconContainer">
                                        <div class="col col-4">
                                            <span class="secondText">Mobile Number</span>
                                        </div>
                                        <div class="col col-6">
                                            <span class="secondDecText">{{singleBooking?.country_code +
                                                singleBooking?.mobile_number}}</span>
                                        </div>
                                    </div>
                                    <div class="row iconContainer">
                                        <div class="col col-4">
                                            <span class="secondText">Note</span>
                                        </div>
                                        <div class="col col-6">
                                            <span class="secondDecText">{{singleBooking?.note}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col" style="margin-top: 1%;">
                                <div class="row iconContainer">
                                    <img class="saveIcon" src="../../../../../assets/icons/bookingMade.png" />
                                    <span class="thirdHeaderText marginLeft">Booking Made By :</span>
                                    <span class="thirdHeaderText marginLeft">
                                        {{singleBooking?.user_type == 'USER'? 'Admin' : 'Customer'}}</span>
                                </div>

                                <div *ngIf="singleBooking?.user_type != 'CUSTOMER'">
                                    <div class="col marginTop bookingUserAdmin">
                                        <div class="row iconContainer">
                                            <div class="col col-4">
                                                <span class="secondText">Full Name</span>
                                            </div>
                                            <div class="col col-6">
                                                <span class="secondDecText">{{singleBooking?.user?.name + " " +
                                                    singleBooking?.user?.last_name}}</span>
                                            </div>
                                        </div>
                                        <div class="row iconContainer">
                                            <div class="col col-4">
                                                <span class="secondText">Email Address</span>
                                            </div>
                                            <div class="col col-6">
                                                <span class="secondDecText">{{singleBooking?.user?.email}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>